import React, { FC } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { IMotorCarrier } from 'apps/fleet-planner/types'
import {
  ELDIntegrationsListMobileItem,
  ELDIntegrationsListMobileSkeleton,
} from './ELDIntegrationsListMobileItem'

type TMotorCarrierEntry = {
  motorCarrier: IMotorCarrier
}

type TItemClickHandler = (motorCarrier: IMotorCarrier) => () => void

interface IELDIntegrationsListMobileProps {
  /**
   * Motor carriers to display
   */
  motorCarriers: TMotorCarrierEntry[]

  /**
   * Should show skeleton loader?
   * @defaults false
   */
  loading: boolean

  /**
   * The function that's fired when the ELD Integration item is clicked
   */
  onItemClick: (motorCarrier: IMotorCarrier) => void
}

export const ELDIntegrationsListMobile: FC<IELDIntegrationsListMobileProps> = ({
  loading = false,
  motorCarriers,
  onItemClick,
}) => {
  const createItemClickHandler: TItemClickHandler = motorCarrier => () => onItemClick(motorCarrier)

  if (loading) {
    return (
      <Box>
        {Array.from({ length: 2 }, () => (
          <ELDIntegrationsListMobileSkeleton />
        ))}
      </Box>
    )
  }

  if (motorCarriers.length === 0) {
    return (
      <Box>
        <Typography>No integrations found.</Typography>
      </Box>
    )
  }

  return (
    <Box>
      {motorCarriers.map(({ motorCarrier }) => (
        <ELDIntegrationsListMobileItem
          key={motorCarrier.id}
          name={motorCarrier?.name}
          isKeepTruckinEnabled={motorCarrier?.isKeepTruckinEnabled}
          keepTruckinConnector={motorCarrier?.keepTruckinConnector}
          clickHandler={createItemClickHandler(motorCarrier)}
        />
      ))}
    </Box>
  )
}
